import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { omit } from 'lodash';
import classnames from 'classnames';
import setDisplayName from 'component-lib/displayName';

import styles from '../BasicButtons.scss';

export default function buttonGenerator(displayName, BASE_CLASS_NAME) {
    const CLASS_NAMES = {
        default: BASE_CLASS_NAME,
        warning: `${BASE_CLASS_NAME}-warning`,
        disabled: `${BASE_CLASS_NAME}-disabled`,
        loading: `${BASE_CLASS_NAME}-loading`,
        disabledLoading: `${BASE_CLASS_NAME}-disabled-loading`,
    };

    const klass = class extends Component {
        static displayName = setDisplayName(displayName);

        static propTypes = {
            children: PropTypes.node.isRequired,
            warning: PropTypes.bool,
            disabled: PropTypes.bool,
            loading: PropTypes.bool,
            extraClassName: PropTypes.string,
        };

        static defaultProps = {
            warning: false,
            disabled: false,
            loading: false,
            extraClassName: '',
        };

        render() {
            const { warning, disabled, children, loading, extraClassName } = this.props;

            let which = 'default';
            const buttonProps = {};

            if (disabled) {
                which = 'disabled';
                buttonProps.disabled = true;

                if (loading) {
                    which = 'disabledLoading';
                }
            } else if (warning) {
                which = 'warning';
            } else if (loading) {
                which = 'loading';
            }

            return (
                <button
                    className={classnames([styles[CLASS_NAMES[which]], extraClassName].filter(name => name))}
                    ref={(button) => {
                        this.button = button;
                    }}
                    {...buttonProps}
                    {...omit(
                        this.props,
                        'warning',
                        'disabled',
                        'children',
                        'loading',
                        'extraClassName',
                        'text',
                        'additionalClass',
                        'showIndicator',
                    )}
                >
                    {loading && <span data-spinner className={styles.spinner} />}
                    {children}
                </button>
            );
        }
    };

    return klass;
}
